import { render, staticRenderFns } from "./CaseDetail.vue?vue&type=template&id=7f18b0db&scoped=true"
import script from "./CaseDetail.vue?vue&type=script&lang=ts"
export * from "./CaseDetail.vue?vue&type=script&lang=ts"
import style0 from "./CaseDetail.vue?vue&type=style&index=0&id=7f18b0db&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f18b0db",
  null
  
)

export default component.exports